export const AUTOCOMPLETE_VALUES = {
  DISABLED: 'autocomplete-disabled',
  CARD_CVV: 'cc-csc',
  CARD_NUMBER: 'cc-number',
  CARD_CARDHOLDER_NAME: 'cc-name',
  CARD_EXP_MONTH: 'cc-exp-month',
  CARD_EXP_YEAR: 'cc-exp-year',
  EMAIL: 'email',
  CARD_ADDRESS_LINE_1: 'address-line1',
  CARD_ADDRESS_LINE_2: 'address-line2',
  CARD_ADDRESS_CITY: 'address-level2',
  CARD_COUNTY_STATE: 'address-level3',
  CARD_ADDRESS_COUNTRY: 'country',
  CARD_ADDRESS_POSTAL_CODE: 'postal-code',
  DIRECT_DEBIT_EMAIL: 'email-dd',
  WALLEY_EMAIL: 'email-walley',
}
